import AccettazioneSsnEditViewPage from "./pages/AccettazioneSsnEditViewPage.vue";
import AccettazioneSsnListPage from "./pages/AccettazioneSsnListaPage.vue";
export default {
    AccettazioneSsnListPage,
    AccettazioneSsnEditViewPage
};
